export default __webpack_public_path__ + "static/media/285hz-tissue-healing-regeneration.5c5ab88e.ogg";